import { render, staticRenderFns } from "./MemberExperts.vue?vue&type=template&id=5ff5760b&scoped=true"
import script from "./MemberExperts.vue?vue&type=script&lang=js"
export * from "./MemberExperts.vue?vue&type=script&lang=js"
import style0 from "./MemberExperts.vue?vue&type=style&index=0&id=5ff5760b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff5760b",
  null
  
)

export default component.exports